import {Injectable} from '@angular/core';
import {ErrorService} from '@services/error.service';
import {HttpClient} from '@angular/common/http';
import {ConfigService} from '@services/infra/config.service';
import {Observable, OperatorFunction} from 'rxjs';
import {filter, map, timeout} from 'rxjs/operators';
import {ClientConfig} from '@app/client-config';
import {ProductQuery, SearchProductResponse} from '@services/resource/search-product-resources';
import {ParamMap} from '@angular/router';
import {ExcelDownloadResponse} from '@services/resource/excel-download-response';
import {AvailableParamsResource} from '@services/resource/available-params-resource';

export class QueryAndIndex {
  constructor(
    public readonly query: ProductQuery,
    public readonly index: number,
  ) {}
}

@Injectable({
  providedIn: 'root',
})
export class SearchproductService {
  constructor(
    private readonly errors: ErrorService,
    private readonly http: HttpClient,
    private readonly conf: ConfigService,
  ) {}

  public static extractQueryAndIndex(): OperatorFunction<ParamMap, QueryAndIndex> {
    return ((params: Observable<ParamMap>) => {
      return params.pipe(
        map((qmp) => {
          const queryString = qmp.get('query');
          const indexString = qmp.get('index') || '0';
          return [queryString, indexString];
        }),
        filter((x) => !!x[0]),
        map((x) => {
          const q = JSON.parse(decodeURIComponent(x[0] as string)) as ProductQuery;
          const i = +(x[1] as string);
          return new QueryAndIndex(q, i);
        }),
      );
    }) as unknown as OperatorFunction<ParamMap, QueryAndIndex>;
  }

  public search(query: ProductQuery): Observable<SearchProductResponse> {
    if (query.offset < 0) {
      query = {...query, offset: 0, limit: 0};
    }
    /* 'undefined' is not a valid status */
    query = {...query, statusIn: query.statusIn ? query.statusIn.filter((x) => !!x) : null};

    const url = `${this.conf.backendUrl}/v1/searchproduct`;
    return this.http.post<SearchProductResponse>(url, query).pipe(
      map((r) => {
        return {...r, query};
      }),
      timeout(ClientConfig.timeout),
      this.errors.withErrorHandler(),
    );
  }
  public getAvailableParams(): Observable<AvailableParamsResource> {
    const url = `${this.conf.backendUrl}/v1/searchproduct/parameters`;
    return this.http.get<AvailableParamsResource>(url).pipe(timeout(ClientConfig.timeout), this.errors.withErrorHandler());
  }

  public generateExport(query: ProductQuery): Observable<ExcelDownloadResponse> {
    const requestUrl = `${this.conf.backendUrl}/v1/excel/start-up-liste`;
    return this.http.post<ExcelDownloadResponse>(requestUrl, query).pipe(timeout(ClientConfig.timeoutLargeRequest), this.errors.withErrorHandler());
  }
}
